import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SalesFunnelDataService } from '../shared/sales-funnel-data.service';
import { ISalesFunnelLayoutChild } from '../shared/sales-funnel-child.module';

@Component({
  selector: 'app-customer-details-component',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './customer-details-component.html',
  styleUrls: ['./customer-details-component.scss']
})
export class CustomerDetailsComponent implements OnInit, ISalesFunnelLayoutChild {
  private router = inject(Router);
  private dataService = inject(SalesFunnelDataService);

  customerForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', Validators.required),
    personalId: new FormControl('', Validators.required),
  })


  salesFunnelIndex = 2;

  ngOnInit(): void {
    const data = this.dataService.getData();
    if (data.customerDetails) {
      this.customerForm.setValue({
        firstName: data.customerDetails.firstName,
        lastName: data.customerDetails.lastName,
        email: data.customerDetails.email,
        phone: data.customerDetails.phone,
        personalId: data.customerDetails.personalId,
      })
    }
  }

  saveDetails(): void {
    this.dataService.updateCustomerDetails({
      firstName: this.customerForm.get('firstName')?.value ?? '',
      lastName: this.customerForm.get('lastName')?.value ?? '',
      email: this.customerForm.get('email')?.value ?? '',
      phone: this.customerForm.get('phone')?.value ?? '',
      personalId: this.customerForm.get('personalId')?.value ?? '',
    });
  }

  sendOffer(): void {
    this.saveDetails();
    this.router.navigate(['/customer-offer']);
  }

  goBack(): void {
    this.saveDetails();
    this.router.navigate(['/package-offer']);
  }
}
